import tw from "twin.macro";

export const LicenseProductCardWrapper = tw.div`
	md:min-w-[22rem]
`;
